/**
 * 工具頁 — 繁體中文（對應 t('tools.…')）
 */
export default {
	dailyEnergy: {
		meta: {
			title: "今日能量 - 先知命局",
			keywords: "今日能量,今日運勢,八字運勢",
			description: "查看你的今日能量與專屬生活指引，了解日運、月運、年運詳情。",
		},
		breadcrumb: "今日能量",
		back: "返回",
		periodTabs: {
			day: "日運",
			month: "月運",
			year: "年運",
		},
		profile: {
			mine: "我的 ›",
			default: "個人檔案",
			selectHint: "點擊下方檔案以切換，並返回今日能量",
			current: "使用中",
			switchFailed: "切換檔案失敗，請稍後再試",
		},
		load: {
			loading: "正在加載運勢...",
		},
		error: {
			title: "暫時無法獲取運勢",
			retry: "重新加載",
			loadFailed: "暫時無法獲取今日能量",
			dateSwitchFailed: "日期切換失敗",
			monthLoadFailed: "月運加載失敗",
			monthBirthUnsupported: "注：本年本月出生的生日暫無法查看月運",
			yearLoadFailed: "年運加載失敗",
		},
		gauge: {
			ariaLabel: "今日能量 {score} 分",
		},
		todayEnergy: "今日能量",
		question: "我的桃花運何時會旺?",
		consult: "立即諮詢",
		viewCalendar: "查看黃曆 →",
		tryLabel: "可以試試:",
		slowLabel: "稍微緩緩:",
		actionAdvice: "行動建議",
		meditation: {
			heading: "聽一段舒緩的療癒之聲",
			viewMore: "去看看",
			playSoon: "即將播放：{name}",
		},
		toast: {
			consultPending: "諮詢功能待接入",
			calendarPending: "黃曆功能待接入",
			meditationPending: "冥想空間待接入",
			sharePending: "分享功能待接入",
		},
		share: "分享",
		sharePanel: {
			cardTitle: "能量卡片",
			shareTo: "分享至",
			saveImage: "保存圖片",
			saving: "保存中…",
			generating: "正在生成能量卡片…",
			generateFailed: "生成分享圖失敗，請稍後再試",
			saveSuccess: "圖片已保存",
			saveFailed: "保存失敗，請稍後再試",
			copyLink: "複製鏈接",
			copySuccess: "鏈接已複製",
			copyFailed: "複製失敗，請稍後再試",
			scanTitle: "掃碼查看你的運勢",
			scanDesc: "助你規劃人生，讓生活更輕鬆",
			defaultShareText: "來看看我的今日能量吧！",
			needDayFortune: "請先切換到日運並加載運勢後再分享",
		},
		pc: {
			periodComingSoon: "月運即將上線",
			periodComingSoonDesc: "PC 端月運內容正在完善中，請先查看日運或年運。",
			sidebar: {
				ariaLabel: "今日能量側欄",
				comingSoon: "功能待接入，敬請期待",
				ai: {
					cardTitle: "AI對話",
					badge: "全球首創 AI 智慧夥伴—MasterS",
					title: "AI 全球首創 AI 智慧夥伴—Master S",
					desc: "深度對話、運勢解讀、生活建議，隨時為你解答。",
					tags: {
						chat: "深度對話",
						fortune: "命理解穎",
						life: "人生建議",
					},
					cta: "立即諮詢",
				},
				expert: {
					title: "想要全年全方位加持？",
					desc: "資深老師一對一解讀，為你量身定製全年運勢方案。",
				},
				reports: {
					title: "深度測算報告",
				},
			},
		},
		dateStrip: {
			ariaLabel: "選擇日期",
		},
		card: {
			createProfile: "建立專屬能量檔案",
			unlock: "解鎖運勢",
			todayEnergy: "今日能量",
			energyStatus: "能量狀態",
			greetingWithName: "{name}，願你順勢而行",
			greetingDefault: "看見此刻，順勢而行",
			levels: {
				abundant: "豐盈",
				stable: "平穩",
				charging: "蓄力",
				rest: "靜養",
			},
		},
		month: {
			deepReport: "深度測算報告",
			reportFallback: ["財", "緣", "紫", "運"],
		},
		year: {
			yearlyAdvice: "年度建議：",
			starRating: "{score} 星",
			teacherFallback: "師",
			experience: "從業年限",
			rating: "評價",
			consultCount: "諮詢人數",
		},
		fallback: {
			unlockText: "解鎖完整運勢",
			practicalAdviceTitle: "今日實用建議",
			lifeTipsTitle: "生活小提醒",
			profileLabel: "我的檔案",
			monthSummaryTitle: "本月運勢總結",
			weeklyTitle: "每週建議",
			monthTitle: "本月建議",
			yearSummaryTitle: "年度運勢總結",
			riskTitle: "核心風險與機會",
			goodAdviceTitle: "好運建議",
			consultButton: "立即諮詢",
			unlockEnergy: "解鎖完整能量指引",
		},
	},
	huangli: {
		meta: {
			title: "黃曆 - 專業日曆",
			keywords: "黃曆,通勝,宜忌,擇日,五行",
			description: "專業黃曆日曆，宜忌、五行、八字、擇日一覽",
			zeriTitle: "擇日",
			zeriDescription: "黃曆擇日，查找適合辦事的好日子",
			zeriListTitle: "擇日結果",
			zeriListDescription: "黃曆擇日結果列表",
			detailTitle: "黃曆詳解",
			detailDescription: "黃曆宜忌、沖煞、吉神凶神詳解",
		},
		breadcrumb: "通勝",
		share: "分享",
		sharePanel: {
			shareTo: "分享至",
			saveImage: "保存圖片",
			saving: "保存中…",
			saveSuccess: "圖片已保存",
			saveFailed: "保存失敗，請稍後再試",
			copyLink: "複製鏈接",
			copySuccess: "鏈接已複製",
			copyFailed: "複製失敗，請稍後再試",
			defaultShareText: "來看看今日黃曆宜忌吧！",
			needData: "請等待黃曆數據加載完成後再分享",
			labels: {
				wuxing: "五行",
				caiwei: "財位",
				xishen: "喜神",
				shengxiao: "生肖",
			},
		},
		aria: {
			breadcrumb: "麵包屑",
			yi: "宜",
			ji: "忌",
			compass: "羅盤",
			prevDay: "前一天",
			nextDay: "後一天",
		},
		nav: {
			huangli: "黃曆",
			zeri: "擇日",
			xiangjie: "詳解",
			fortune: "運勢",
		},
		load: {
			loading: "加載中...",
		},
		empty: {
			noData: "暫無數據",
		},
		common: {
			cancel: "取消",
			confirm: "確定",
			yi: "宜",
			ji: "忌",
			yearSuffix: "{n}年",
			monthSuffix: "{n}月",
			daySuffix: "{n}日",
			yearMonth: "{y}年{m}月",
			age: "{n}歲",
			heidao: "黑道",
			huangdao: "黃道",
		},
		dayPanel: {
			prevDay: "前一天",
			nextDay: "後一天",
			selectDate: "選擇日期",
			dir: {
				xi: "喜",
				cai: "財",
				gui: "貴",
				sheng: "生",
			},
			labels: {
				todayWuxing: "今日五行",
				tiangan: "天干",
				dizhi: "地支",
				nayin: "納音",
				ershibaXiu: "廿八宿",
				shierShen: "十二神",
				todayBazi: "今日八字",
				pengzu: "彭祖百忌",
				luckShengxiao: "幸運生肖",
				todayTaishen: "今日胎神",
				wuhou: "物候",
				dailyLuckStar: "每日吉星",
				rilu: "日祿",
				jinfujing: "金符經",
			},
		},
		calendar: {
			goZeri: "去擇日",
			prevMonth: "上個月",
			nextMonth: "下個月",
			backToday: "回到今天",
			ganzhiYear: "{gz}{animal}年",
			weekdays: {
				sun: "日",
				mon: "一",
				tue: "二",
				wed: "三",
				thu: "四",
				fri: "五",
				sat: "六",
			},
		},
		detail: {
			title: "黃曆詳解",
			titleWithDate: "{y}年{m}月{d}日 詳解",
			yiJiFallback: "宜忌",
			emptyYi: "諸事不宜",
			emptyJi: "百無禁忌",
			tabs: {
				yiJi: "宜忌",
				chongSha: "沖煞",
				jiSheng: "吉神",
				xiongShen: "凶神",
				huangDao: "黃黑道",
				siZhu: "四柱",
				shengXiao: "生肖",
				wuXing: "五行",
				taiShen: "胎神",
				pengZu: "彭祖",
				xingYao: "星曜",
			},
		},
		zeri: {
			title: "擇日",
			typeSelectTitle: "擇日類型選擇",
			titleWithName: "{name} 擇日",
			countHintBefore: "未來一年約有",
			countHintAfter: "天適合{name}",
			monthAuspicious: "{month}{name}吉日共",
			monthDayUnit: "日",
			lunarPrefix: "農曆",
			empty: "暫無適合{name}的日期",
			chongPrefix: "沖{animal}",
			jiShiPrefix: "吉時：",
		},
	},
};
